<template>
  <el-affix>
    <div class="top">
     <div class="mainTop">
        <el-row>
          <el-col :span="4"
            ><div class="Icon">
              <div class="name">米伯希</div>
            </div>
          </el-col>
          <el-col :span="16">
            <el-menu
              :default-active="activeIndex"
              class="el-menu-demo"
              mode="horizontal"
              :ellipsis="false"
              @select="handleSelect"
            >
              <el-menu-item index="首页">首页</el-menu-item>
              <el-menu-item index="职位推荐">职位推荐</el-menu-item>
              <el-menu-item index="职位搜索">职位搜索</el-menu-item>
              <el-menu-item index="消息">
                <el-badge :value="unreadCount" :max="99" :hidden="unreadCount === 0">
                  <span>消息</span>
                </el-badge>
              </el-menu-item>
              <el-sub-menu index="4">
                <template #title>求职服务</template>
                <el-menu-item index="简历模版">简历模版</el-menu-item>
                <el-menu-item index="AI求助">AI求助</el-menu-item>
              </el-sub-menu>
              <el-menu-item index="关于我">关于我</el-menu-item>
            </el-menu>
          </el-col>
          <el-col :span="4" class="avater_name">
            <div class="block">
              <img class="touPic" src="/public/images/默认图像.png" />
            </div>
            <p style="margin-left: 10px">{{ store.state.userInfo.username }}</p>
            <div class="lin">|</div>
            <div class="out" @click="outLogin()">退出登录</div>
          </el-col>
        </el-row>
      </div>
    </div>
   
  </el-affix>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import store from "@/store/index.js";
import {useJobStore} from "@/store/pinia_Job.js"
import {useSearchStore} from "@/store/searchPinia.js"
const route = useRoute();
const router = useRouter();
const activeIndex = ref("1");
import axios from "../util/axios.config";

// 未读消息数
const unreadCount = computed(() => store.state.unreadMessageCount || 0);

// 轮询更新未读消息数
let unreadPollingTimer = null;
const loadUnreadCount = async () => {
  try {
    const { data } = await axios.get('/staffapi/chat/unread-count');
    if (data.ActionType === 'ok') {
      store.commit('setUnreadMessageCount', data.totalUnread || 0);
    }
  } catch (error) {
    console.error('加载未读消息数失败:', error);
  }
};

// 启动轮询（每5秒更新一次）
const startUnreadPolling = () => {
  // 立即加载一次
  loadUnreadCount();
  
  // 每5秒轮询一次
  unreadPollingTimer = setInterval(() => {
    loadUnreadCount();
  }, 5000);
};

// 停止轮询
const stopUnreadPolling = () => {
  if (unreadPollingTimer) {
    clearInterval(unreadPollingTimer);
    unreadPollingTimer = null;
  }
};

onMounted(() => {
  // 组件挂载时启动轮询
  startUnreadPolling();
});

onUnmounted(() => {
  // 组件卸载时停止轮询
  stopUnreadPolling();
});
const handleSelect = (keyPath) => {
  console.log(keyPath);
  //获取当前路由
  console.log("Current route:", route.path);
  if (keyPath == "首页") {
    if (route.path == "/home") {
      return;
    } else {
      router.push("/home");
    }
  } else if (keyPath == "职位推荐") {
    if (route.path == "/recommend") {
      return;
    } else {
      router.push("/recommend");
    }
  } else if (keyPath == "职位搜索") {
    if (route.path == "/searchJob") {
      return;
    } else {
      router.push("/searchJob");
    }
  } else if (keyPath == "消息") {
    if (route.path == "/chat") {
      return;
    } else {
      router.push("/chat");
    }
  } else if(keyPath == "关于我"){
    if (route.path == "/person") {
      return;
    } else {
      router.push("/person");
    }
  }
};
const outLogin = () => {
  const piniaJob = useJobStore();
  const searchPinia = useSearchStore();
  axios.post("/staffapi/user/curriculum/updateLastLook",{
    username:store.state.userInfo.username,
    lastLook:store.state.lastLook
  }).then((res) => {
    console.log(res);
  }).catch((err) => {
    console.log(err);
  });
  localStorage.removeItem("token");
  store.commit("clearUserInfo"); //清空用户信息
  store.commit("clearLastLook"); //清空用户最后浏览记录
  store.commit("clearUnreadMessageCount"); //清空未读消息数
  piniaJob.reset(); //清空pinia数据
  searchPinia.reset(); //清空pinia数据
  stopUnreadPolling(); //停止轮询
  router.push("/login");
};
</script>

<style lang="scss" scoped>
.top{
  background-color: #fff;
  width: 100%;
  height: fit-content;
}
.mainTop {
  background-color: #fff;
  max-width: 1400px;
  margin: 0 auto;
}
.Icon {
  margin-left: 20px;
  width: 100px;
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: orange;
  color: white;
  .name {
    font-family: "阿里妈妈方圆体 VF Regular";
    font-size: 25px;
    font-weight: 700;
  }
}
@font-face {
  font-family: "阿里妈妈方圆体 VF Regular";
  src: url("../fontResource/KCBE3ffOGlMG.woff2") format("woff2"),
    url("../fontResource/KCBE3ffOGlMG.woff") format("woff");
}
.avater_name {
  display: flex;
  align-items: center;
}
.el-menu--horizontal.el-menu {
  display: flex;
  justify-content: center;
  border-bottom: none;
}
.el-menu--horizontal > .el-menu-item {
  font-size: large;
}
::v-deep .el-menu--horizontal > .el-sub-menu .el-tooltip__trigger {
  font-size: large;
}
.lin {
  margin-left: 10px;
  font-size: 20px;
  color: rgb(215, 210, 210);
}
.out {
  margin-left: 10px;
  cursor: pointer;
  font-size: 15px;
  color: rgb(36, 86, 236);
}
.touPic{
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
</style>
